import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: 1,
            refetchOnWindowFocus: false,
            staleTime: 10000, // 10 seconds
            gcTime: 5 * 60 * 1000 // 5 minutes
        },
        mutations: {
            retry: 0
        }
    }
});
